'use strict';
var removeAccents = require('remove-accents-diacritics');

/**
 * Parse a Google address response
 * @param {Object} place The google place object
 * @returns {Object} A normalized address
 */
function parsePlace(place) {
    place = place || {};

    /**
     * Set the data by type
     * @param {Object} obj combined address object from google places
     * @param {Object} data object from google places
     * @param {string} type type of address property
     * @returns {Object} Reduced object with address properties as keys
     */
    function setData(obj, data, type) {
        if (!obj[type]) {
            obj[type] = {};
        }
        if (data.short_name) {
            if (obj[type].short_name) {
                obj[type].short_name = data.short_name + obj[type].short_name;
            } else {
                obj[type].short_name = data.short_name;
            }
        }
        if (data.long_name) {
            if (obj[type].long_name) {
                obj[type].long_name = data.long_name + obj[type].long_name;
            } else {
                obj[type].long_name = data.long_name;
            }
        }
        if (!data.short_name && !data.long_name) {
            obj[type] = data;
        }
        return obj;
    }

    var byType = (place.address_components || []).reduce(function (acc, data) {
        data.types.forEach(function (type) {
            setData(acc, data, type);
        });
        return acc;
    }, {});

    /**
     * Get the key of the place by type
     * @param {string} key the google places address level type
     * @param {boolean} short whether or not to return the short version of the type
     * @returns {string} The address value
     */
    function placeGet(key, short) {
        if (!(key in byType)) return '';
        var placeType = short
            ? byType[key].short_name
            : byType[key].long_name || byType[key].short_name;
        var normalizedPlace = removeAccents.remove(placeType);
        return normalizedPlace;
    }

    var result = {
        streetNumber: placeGet('street_number'),
        streetName: placeGet('route')
            ? placeGet('route') +
              (placeGet('premise') ? ' ' + placeGet('premise') : '')
            : placeGet('sublocality_level_2') +
              placeGet('sublocality_level_3') +
              placeGet('sublocality_level_4') +
              (placeGet('premise') ? '−' + placeGet('premise') : ''),
        city:
            placeGet('locality') ||
            placeGet('sublocality') ||
            placeGet('sublocality_level_1') ||
            placeGet('neighborhood') ||
            placeGet('administrative_area_level_3') ||
            placeGet('administrative_area_level_2') ||
            placeGet('postal_town'),
        county: placeGet('administrative_area_level_2'),
        stateShort: placeGet('administrative_area_level_1', true),
        stateLong: placeGet('administrative_area_level_1'),
        countryShort: placeGet('country', true),
        countryLong: placeGet('country'),
        zipCode: placeGet('postal_code')
    };

    result.address = result.streetNumber + ' ' + result.streetName;
    result.lat = place.geometry.location.lat();
    result.lng =  place.geometry.location.lng();

    return result;
}

module.exports = parsePlace;
